// Icons-only entry to avoid importing client-hook components from the main bundle

// Standardized Lucide re-exports (preferred) - Icon prefix naming convention
export { IconAlertCircle } from "./icons/alert-circle-icon";
// Brand/Payment icons (updated to use standardized Icon prefix naming)
export { IconAmex } from "./icons/amex-icon";
export { IconAngleRight } from "./icons/angle-right-icon";
export { IconArrowCircle } from "./icons/arrow-circle-icon";
export { IconArrowLeft } from "./icons/arrow-left-icon";
export { IconArrowRight } from "./icons/arrow-right-icon";
export { IconBackpack } from "./icons/backpack-icon";
export { IconAvantiBrand } from "./icons/brand-avanti-icon";
export { IconBergamontBrand } from "./icons/brand-bergamont-icon";
export { IconDolomiteBrand } from "./icons/brand-dolomite-icon";
export { IconGranvilleBrand } from "./icons/brand-granville-icon";
export { IconMalvernStarBrand } from "./icons/brand-malvern-star-icon";
export { IconScottBrand } from "./icons/brand-scott-icon";
export { IconSheppardBrand } from "./icons/brand-sheppard-icon";
export { IconSyncrosBrand } from "./icons/brand-syncros-icon";
export { IconCalendar } from "./icons/calendar-icon";
export { IconCalendarRange } from "./icons/calendar-range-icon";
export { IconCart } from "./icons/cart-icon";
export { IconCheck } from "./icons/check-icon";
export { IconChevronDown } from "./icons/chevron-down-icon";
export { IconChevronRight } from "./icons/chevron-right-icon";
export { IconChevronTop } from "./icons/chevron-top-icon";
export { IconChevronUpDown } from "./icons/chevron-up-down-icon";
export { IconClose } from "./icons/close-icon";
export { IconDocumentPlus } from "./icons/document-plus-icon";
export { IconDownload } from "./icons/download-icon";
export { IconFacebook } from "./icons/facebook-icon";
export { IconFileDown } from "./icons/file-down-icon";
export { IconFileUp } from "./icons/file-up-icon";
export { IconGeoLocation } from "./icons/geo-location-icon";
export { IconGlobe } from "./icons/globe-icon";
export { IconHeart } from "./icons/heart-icon";
export { IconHelp } from "./icons/help-icon";
export { IconHouse } from "./icons/house-icon";
export { IconVideoCheck } from "./icons/icon-video-check";
export { IconVideoChevronLeft } from "./icons/icon-video-chevron-left";
export { IconVideoChevronRight } from "./icons/icon-video-chevron-right";
export { IconVideoPause } from "./icons/icon-video-pause";
export { IconVideoPip } from "./icons/icon-video-pip";
export { IconVideoPlay } from "./icons/icon-video-play";
export { IconVideoSeekBack } from "./icons/icon-video-seek-back";
export { IconVideoSeekForward } from "./icons/icon-video-seek-forward";
export { IconVideoSpeed } from "./icons/icon-video-speed";
export { IconVideoSubtitles } from "./icons/icon-video-subtitles";
export { IconVideoVolumeHigh } from "./icons/icon-video-volume-high";
export { IconVideoVolumeLow } from "./icons/icon-video-volume-low";
export { IconVideoVolumeMuted } from "./icons/icon-video-volume-muted";
// Icon types
export type {
  IconColor,
  IconSize,
  IconWrapperProps,
} from "./icons/icon-wrapper";
export { IconInstagram } from "./icons/instagram-icon";
export { IconKlarna } from "./icons/klarna-icon";
export { IconLoader2 } from "./icons/loader2-icon";
export { IconMagnifyingGlass } from "./icons/magnifying-glass-icon";
export { IconMastercard } from "./icons/mastercard-icon";
export { IconMaximize } from "./icons/maximize-icon";
export { IconMinusCircle } from "./icons/minus-circle-icon";
export { IconMinus } from "./icons/minus-icon";
export { IconMoreVertical } from "./icons/more-vertical-icon";
export { IconPanelLeftClose } from "./icons/panel-left-icon";
export { IconPaypal } from "./icons/paypal-icon";
export { IconPen } from "./icons/pen-icon";
export { IconPinterest } from "./icons/pinterest-icon";
export { IconPlusCircle } from "./icons/plus-circle-icon";
export { IconPlus } from "./icons/plus-icon";
export { IconPower } from "./icons/power-icon";
export { IconScottBike } from "./icons/scott-bike-icon";
export { IconScottRunning } from "./icons/scott-running-icon";
export { IconScottWinter } from "./icons/scott-winter-icon";
export { IconSearch } from "./icons/search-icon";
export { IconShoppingCart } from "./icons/shopping-cart-icon";
export { IconStore } from "./icons/store-icon";
export { IconTick } from "./icons/tick-icon";
export { IconTrash } from "./icons/trash-icon";
export { IconTrash2 } from "./icons/trash2-icon";
export { IconTruck } from "./icons/truck-icon";
export { IconUser } from "./icons/user-icon";
export { IconUsers } from "./icons/users-icon";
export { IconVisa } from "./icons/visa-icon";
export { IconXCircle } from "./icons/x-circle-icon";
export { IconX } from "./icons/x-icon";
export { IconXMark } from "./icons/x-mark-icon";
export { IconYoutube } from "./icons/youtube-icon";
